import { Link } from "react-router-dom";

export default function Footer({ settings }) {
  const year = new Date().getFullYear();
  const socials = settings?.socials || {};
  const streaming = settings?.streaming || {};
  return (
    <footer data-testid="footer" className="border-t border-white/10 px-6 py-14 pb-28 sm:px-10 lg:px-16">
      <div className="mx-auto max-w-6xl">
        <div className="grid gap-10 md:grid-cols-4">
          <div>
            <h3 className="font-display text-2xl font-bold uppercase tracking-tight text-white">
              DJ <span className="text-gold">Código</span>
            </h3>
            <p className="mt-2 text-sm font-semibold text-white/80">{settings?.tagline || "Dominican Roots. Global Sound."}</p>
            <p className="mt-2 max-w-xs text-xs text-white/50">{settings?.genreLine || "Latin Urban • Reggaetón • Hip-Hop • Caribbean Club Music"}</p>
            {settings?.booking?.email && <a href={`mailto:${settings.booking.email}`} className="mt-3 inline-block text-xs text-white/50 hover:text-gold">Booking: {settings.booking.email}</a>}
          </div>

          <div>
            <p className="mb-3 text-xs font-bold uppercase tracking-widest text-gold">Explore</p>
            <ul className="space-y-2 text-sm text-white/60">
              {[["/#latest-releases", "Music"], ["/videos", "Videos"], ["/about", "About DJ Código"], ["/news", "News & Stories"], ["/press", "Press / EPK"], ["/#join", "Join the Código List"]].map(([to, l]) => (
                <li key={to}><Link to={to} className="transition-colors hover:text-gold">{l}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <p className="mb-3 text-xs font-bold uppercase tracking-widest text-gold">Social</p>
            <ul className="space-y-2 text-sm text-white/60">
              {Object.entries(socials).filter(([, v]) => v).map(([k, v]) => (
                <li key={k}>
                  <a href={v} target="_blank" rel="noopener noreferrer" className="capitalize transition-colors hover:text-gold">{k}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="mb-3 text-xs font-bold uppercase tracking-widest text-gold">Music</p>
            <ul className="space-y-2 text-sm text-white/60">
              {Object.entries(streaming).filter(([, v]) => v).map(([k, v]) => (
                <li key={k}>
                  <a href={v} target="_blank" rel="noopener noreferrer" className="capitalize transition-colors hover:text-gold">{k.replace("_", " ")}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-6 text-xs text-white/40 sm:flex-row sm:items-center">
          <p>© {year} DJ Código. All rights reserved.</p>
          <div className="flex gap-5">
            <Link to="/privacy" className="transition-colors hover:text-gold">Privacy</Link>
            <Link to="/terms" className="transition-colors hover:text-gold">Terms</Link>
            <Link to="/admin" className="transition-colors hover:text-gold">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
